import React from 'react';
import classNames from 'classnames';
import { string, oneOf } from 'prop-types';
import { Tooltip } from '@thd-olt-component-react/tooltip';
import { buildImageURL } from '../../../utils/product-add-on-utils';
import { ICONS } from '../../../utils/product-add-on-constants';
import { getDualPathCategoryModel } from './dualPathTooltipCategories';

const DualPathTooltip = React.forwardRef(({ channel, category }, buttonRef) => {

  const toolTipLabelClasses = classNames({
    'u__default-link': true,
    'product-add-on-tooltip-content__label': true,
    scrollTouch: channel === 'mobile',
  });

  const tooltipContent = (
    <div className="product-add-on-tooltip-content" data-channel={`${channel}`}>
      <div className="product-add-on-tooltip-content__header">How it Works</div>
      <ul className="product-add-on-tooltip-content__list">
        {getDualPathCategoryModel(category).map((list, index) => <li key={index}> {list} </li>)}
      </ul>

      <div className="product-add-on-tooltip-content__legal">
        <p>*Some brands and services may vary by market.</p>
        <p>
          Please note by selecting the “Get Expert In-Home Installation” box,
          you consent to being contacted by local professionals after submitting your request.
        </p>
      </div>
    </div>
  );

  return (
    <Tooltip channel={channel} placement="bottom" content={tooltipContent} closeButton>
      <button type="button" className={toolTipLabelClasses} ref={buttonRef}>
        What to Expect
        <img
          src={buildImageURL(ICONS.info)}
          alt="information tooltip"
          className="product-add-on-tooltip-content__label__suffix"
          width="1"
          height="1"
        />
      </button>
    </Tooltip>
  );
});

DualPathTooltip.displayName = 'ProductAddOns-dualPath-tooltip';

DualPathTooltip.propTypes = {
  /** What view to render ['desktop' || 'mobile']  */
  channel: oneOf(['desktop', 'mobile']),
  category: string
};

DualPathTooltip.defaultProps = {
  channel: 'desktop',
  category: 'brio_inaisle_sfi_generalfs'
};

export { DualPathTooltip };